export const whatIsPreapprovedFaqUrl =
    'https://help.totallymoney.com/en/articles/4039106'

export const financialEssentialsFaqUrl =
    'https://help.totallymoney.com/en/categories/937026-your-financial-essentials'

export const allLinks = [whatIsPreapprovedFaqUrl, financialEssentialsFaqUrl]
